<script setup lang="ts">
import { computed } from 'vue'
import GlassCard from '@/shared/components/GlassCard.vue'
import ContactForm from '@/shared/components/ContactForm.vue'

const props = defineProps<{ diagnosisSessionId?: string }>()

// The completed AI session rides along; the backend composes the hidden
// summary for the receiving professional from it.
const context = computed(() =>
    props.diagnosisSessionId ? { diagnosis_session_id: props.diagnosisSessionId } : undefined,
)
</script>

<template>
    <section id="pro" class="site-section">
        <div class="site-content narrow">
            <GlassCard>
                <ContactForm
                    :context="context"
                    :subheading="
                        diagnosisSessionId
                            ? 'Your AI analysis is attached automatically, so the professional shows up already knowing your situation — no re-explaining.'
                            : undefined
                    "
                />
            </GlassCard>
        </div>
    </section>
</template>

<style scoped lang="scss">
.narrow {
    max-width: 46rem;
}
</style>
